import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Youtube, Linkedin, MessageCircle } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { useSite } from "@/lib/site";

const SOCIAL = [
  { key: "instagram", Icon: Instagram, label: "إنستغرام" },
  { key: "youtube", Icon: Youtube, label: "يوتيوب" },
  { key: "linkedin", Icon: Linkedin, label: "لينكدإن" },
];

const Col = ({ title, links }) => (
  <div>
    <h4 className="font-bold text-white mb-4">{title}</h4>
    <ul className="space-y-2.5 text-sm">
      {links.map(([to, label]) => (
        <li key={to}><Link to={to} className="text-white/70 hover:text-[var(--gold)] transition-colors" data-testid={`footer-link-${to.replace(/\//g, "") || "home"}`}>{label}</Link></li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const { settings } = useSite();
  const c = settings?.contact || {};
  const s = settings?.social || {};
  return (
    <footer className="bg-[#1F1815] text-white mt-24" data-testid="site-footer">
      <div className="container-x py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-4">
          <Logo className="h-12" testId="footer-logo" dark />
          <p className="text-sm text-white/70 leading-relaxed">{settings?.slogan}</p>
          <div className="flex gap-3">
            {SOCIAL.filter((x) => s[x.key]).map(({ key, Icon, label }) => (
              <a key={key} href={s[key]} target="_blank" rel="noreferrer" aria-label={label} data-testid={`footer-social-${key}`} className="p-2 rounded-full bg-white/10 hover:bg-[var(--copper)] transition-colors"><Icon size={18} /></a>
            ))}
            {c.whatsapp && /\d/.test(c.whatsapp) && (
              <a href={`https://wa.me/${c.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" aria-label="واتساب" data-testid="footer-social-whatsapp" className="p-2 rounded-full bg-white/10 hover:bg-[var(--copper)] transition-colors"><MessageCircle size={18} /></a>
            )}
          </div>
        </div>
        <Col title="روابط سريعة" links={[["/courses", "جميع الدورات"], ["/upcoming", "الدورات القادمة"], ["/about", "من نحن"], ["/contact", "تواصل معنا"]]} />
        <Col title="معلومات" links={[["/faq", "الأسئلة الشائعة"], ["/verify", "التحقق من الشهادات"], ["/privacy", "سياسة الخصوصية"], ["/terms", "شروط الاستخدام"], ["/refund", "سياسة الإلغاء والاسترداد"]]} />
        <div>
          <h4 className="font-bold text-white mb-4">تواصل معنا</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-center gap-2" data-testid="footer-phone"><Phone size={16} className="text-[var(--gold)]" /><span dir="ltr">{c.phone}</span></li>
            <li className="flex items-center gap-2" data-testid="footer-email"><Mail size={16} className="text-[var(--gold)]" />{c.email}</li>
            <li className="flex items-center gap-2"><MapPin size={16} className="text-[var(--gold)]" />{c.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">© {new Date().getFullYear()} {settings?.site_name || "أكاديمية هِمّة تم"} — جميع الحقوق محفوظة</div>
    </footer>
  );
};
